import { useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import {
  Plus,
  RefreshCcw,
  Search,
  Pencil,
  X,
  Loader2,
  Calendar,
  FilePlus2,
  Table,
  History,
  IndianRupee,
  BadgeInfo,
} from "lucide-react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import MyContext from "../../../MyContext";
import "./CreditStyle.css";
import Loader from "../../Whatsapp/Loader";
import loader from "../../../images/Anlook.svg";
import AddVendorPurchaseModal from "./AddVendorPurchaseModal";
import "../../Inventory/Inventory/InventoryAccordion.css";
/** Endpoints */
const API = {
  LIST: "/api/Inventory/v1.0/getVendors",
  ADD: "/api/Inventory/v1.0/addVendor",
  EDIT: "/api/Inventory/v1.0/editVendor",
  DEL: "/api/Inventory/v1.0/deleteVendor",
  PAY: "/api/Transactions/v1.0/processVendorPayment",
  PURCHASE_ADD: "/api/Inventory/v1.0/insertVendorPurchaseDetails",
  PURCHASE_LIST: "/api/Inventory/v1.0/getVendorPurchaseDetails",
  VENDOR_BALANCE: "/api/Transactions/getWalletDetails",
};

const BASIC_AUTH = "YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=";

/** Static options */
const VENDOR_TYPES = [
  "Retailers",
  "Service providers",
  "Manufacturer",
  "Wholesaler",
  "Wholesalers or distributors",
  "Independent craftspeople",
  "B2c vendors",
  "Independent Vendor",
  "B2b",
  "Service vendors",
  "Retail vendors",
];
const PRODUCT_CATEGORIES = [
  "Electronics",
  "Dairy",
  "Toys",
  "Grocery",
  "Fresh Produce",
  "Meat & Seafood",
  "Bakery",
  "Beverages",
  "Frozen",
  "Household",
  "Personal Care",
  "Stationery",
  "Apparel",
  "Hardware",
  "Automotive",
  "Pharmacy",
  "Beauty",
  "Baby",
  "Pet Care",
  "Other",
];

/** Helpers */
const val = (...candidates) => {
  for (const c of candidates) {
    if (c !== undefined && c !== null && c !== "") return c;
  }
  return undefined;
};
const toCurrency = (numLike) => {
  const n = Number(numLike);
  if (Number.isFinite(n)) return `₹ ${n.toFixed(2)}`;
  const m = String(numLike ?? "").match(/^\d+(\.\d+)?$/);
  if (m) return `₹ ${Number(numLike).toFixed(2)}`;
  return "₹ —";
};
const maskAcct = (s) => {
  const str = String(s || "");
  if (!str) return "—";
  if (str.length <= 6) return str;
  return `${str.slice(0, 2)}••••••${str.slice(-4)}`;
};
const fmtDate = (s) => (s ? String(s) : "—");
const yes = (v) => String(v ?? "").toUpperCase() === "Y";

export default function VendorManager({ userID }) {
  const { baseUrl } = useContext(MyContext);
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("vendors"); // vendors | purchases

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState("");

  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("add");
  const [editing, setEditing] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  // Payment (from Purchase table)
  const [payOpen, setPayOpen] = useState(false);
  const [paying, setPaying] = useState(false);
  const [payAmount, setPayAmount] = useState("");
  const [payMode, setPayMode] = useState("imps"); // 'imps' | 'cash'
  const [payContext, setPayContext] = useState({
    vendorId: null,
    purchaseId: null,
    vendorName: "",
  });
  // Global Add Purchase (top button using v2.0 API)
  const [globalPurchaseOpen, setGlobalPurchaseOpen] = useState(false);

  // Add Purchase (from vendor row)
  const [purchaseOpen, setPurchaseOpen] = useState(false);
  const [purchaseVendor, setPurchaseVendor] = useState(null);
  const [addingPurchase, setAddingPurchase] = useState(false);
  const [purchaseForm, setPurchaseForm] = useState({
    amount: "",
    purchaseDescription: "",
    purchaseDate: new Date().toISOString().slice(0, 10),
  });

  // Purchase History
  const today = new Date().toISOString().slice(0, 10);
  const [purchaseRows, setPurchaseRows] = useState([]);
  const [purchaseLoading, setPurchaseLoading] = useState(false);
  const [fromDate, setFromDate] = useState(today); // default = today
  const [toDate, setToDate] = useState(today); // default = today

  // Drawer form
  const [form, setForm] = useState({
    vendorName: "",
    vendorType: "",
    vendorCategory: "",
    vendorAddress: "",
    gst: "",
    mobile: "",
    state: "",
    city: "",
    accountNumber: "",
    ifscCode: "",
    vendorId: null,
  });
  const [vendorBalance, setvendorBalance] = useState("");
  const [LoadingList, setLoadingList] = useState(false);

  const call = (path, payload) =>
    axios.post(`${baseUrl}${path}`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${BASIC_AUTH}`,
      },
    });

  /** Load vendors */
  async function fetchVendors() {
    if (!userID) return toast.error("Missing userid");
    try {
      setLoading(true);
      const res = await call(API.LIST, { userid: userID });
      if (res?.data?.responseCode === "00") {
        setRows(Array.isArray(res.data.response) ? res.data.response : []);
      } else {
        setRows([]);
        // toast.error(res?.data?.responseMessage || "Failed to fetch vendors");
      }
    } catch (e) {
      console.error(e);
      toast.error("API error while fetching vendors");
    } finally {
      setLoading(false);
    }
  }

  async function fetchVendorsBalance() {
    if (!userID) return toast.error("Missing userid");
    setvendorBalance("Loading");
    try {
      setLoading(true);
      const res = await call(API.VENDOR_BALANCE, { userid: userID });
      if (res?.data?.responseCode === "00") {
        setvendorBalance(res.data.response.vendorPaymentBalance);
      } else {
        setvendorBalance("");
        toast.error(res?.data?.responseMessage || "Failed to fetch vendors");
        setvendorBalance("N/A");
      }
    } catch (e) {
      console.error(e);
      toast.error("API error while fetching vendors");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchVendorsBalance();
  }, []); // eslint-disable-line

  /** Add/Edit/Delete vendor */
  async function addVendor(payload) {
    try {
      setSubmitting(true);
      const res = await call(API.ADD, {
        userid: userID,
        vendorName: payload.vendorName,
        vendorType: payload.vendorType,
        vendorAddress: payload.vendorAddress,
        vendorCategory: payload.vendorCategory,
        gst: payload.gst,
        mobile: payload.mobile,
        state: payload.state,
        city: payload.city,
        accountNumber: payload.accountNumber,
        ifscCode: payload.ifscCode,
      });
      if (res?.data?.responseCode === "00") {
        toast.success(res?.data?.responseMessage || "Vendor added");
        setOpen(false);
        fetchVendors();
      } else {
        toast.error(res?.data?.responseMessage || "Add failed");
      }
    } catch (e) {
      console.error(e);
      toast.error("API error while adding vendor");
    } finally {
      setSubmitting(false);
    }
  }

  async function editVendor(payload) {
    try {
      setSubmitting(true);
      const res = await call(API.EDIT, {
        userid: userID,
        vendorId: payload.vendorId,
        vendorName: payload.vendorName,
        vendorType: payload.vendorType,
        vendorAddress: payload.vendorAddress,
        vendorCategory: payload.vendorCategory,
        gst: payload.gst,
        mobile: payload.mobile,
        state: payload.state,
        city: payload.city,
        accountNumber: payload.accountNumber,
        ifscCode: payload.ifscCode,
      });
      if (res?.data?.responseCode === "00") {
        toast.success(res?.data?.responseMessage || "Vendor updated");
        setOpen(false);
        setEditing(null);
        fetchVendors();
      } else {
        toast.error(res?.data?.responseMessage || "Update failed");
      }
    } catch (e) {
      console.error(e);
      toast.error("API error while updating vendor");
    } finally {
      setSubmitting(false);
    }
  }

  async function deleteVendor(vendorId) {
    if (!window.confirm("Delete this vendor? This cannot be undone.")) return;
    try {
      setSubmitting(true);
      const res = await call(API.DEL, { userid: userID, vendorId });
      if (res?.data?.responseCode === "00") {
        toast.success(res?.data?.responseMessage || "Vendor deleted");
        fetchVendors();
      } else {
        toast.error(res?.data?.responseMessage || "Delete failed");
      }
    } catch (e) {
      console.error(e);
      toast.error("API error while deleting vendor");
    } finally {
      setSubmitting(false);
    }
  }

  /** Pay (from purchase row) */
  function openPayFromPurchase(pRow, mode = "imps") {
    const vendorId = String(val(pRow.fk_vendor_id, pRow.vendorId, ""));
    const purchaseId = String(val(pRow.id, pRow.purchaseId, ""));
    if (!vendorId || !purchaseId) return toast.error("Missing vendorId or purchaseId on this row");

    setPayContext({
      vendorId,
      purchaseId,
      vendorName: val(pRow.vendor_name, pRow.vendorName, `Vendor ${vendorId}`),
    });
    // Lock amount to the purchase amount; no editing in modal
    setPayAmount(String(val(pRow.amount, "")).replace(/[^\d.]/g, ""));
    setPayMode(mode); // 'imps' or 'cash'
    setPayOpen(true);
  }
  function closePay() {
    if (!paying) setPayOpen(false);
  }
  function validateAmount(v) {
    if (!v) return "Amount is required";
    if (!/^\d+(\.\d{1,2})?$/.test(v)) return "Enter a valid amount (max 2 decimals)";
    if (Number(v) <= 0) return "Amount must be greater than 0";
    return null;
  }
  async function processVendorPaymentUnified() {
    const err = validateAmount(payAmount);
    if (err) return toast.warning(err);
    if (!payContext.vendorId || !payContext.purchaseId) return toast.error("Missing vendor/purchase");

    try {
      setPaying(true);
      const res = await call(API.PAY, {
        userid: userID,
        amount: String(payAmount),
        vendorId: String(payContext.vendorId),
        purchaseId: String(payContext.purchaseId),
        mode: payMode, // 'imps' or 'cash'
      });
      if (res?.data?.responseCode === "00") {
        toast.success(res?.data?.responseMessage || "Payment processed");
        setPayOpen(false);
        if (fromDate && toDate) fetchVendorPurchaseDetails();
      } else {
        toast.error(res?.data?.responseMessage || "Payment failed");
      }
    } catch (e) {
      console.error(e);
      toast.error("API error while processing payment");
    } finally {
      setPaying(false);
    }
  }

  /** Add Purchase */
  function openAddPurchase(row) {
    setPurchaseVendor(row);
    setPurchaseForm({
      amount: "",
      purchaseDescription: "",
      purchaseDate: new Date().toISOString().slice(0, 10),
    });
    setPurchaseOpen(true);
  }
  function closeAddPurchase() {
    if (!addingPurchase) setPurchaseOpen(false);
  }
  function validatePurchaseForm({ amount, purchaseDate }) {
    const aerr = validateAmount(amount);
    if (aerr) return aerr;
    if (!purchaseDate) return "Purchase date is required";
    return null;
  }
  async function submitAddPurchase() {
    if (!purchaseVendor) return toast.error("Missing vendor");
    const err = validatePurchaseForm(purchaseForm);
    if (err) return toast.warning(err);

    try {
      setAddingPurchase(true);
      const vendorId = val(purchaseVendor.id, purchaseVendor.vendorId);
      const res = await call(API.PURCHASE_ADD, {
        userid: userID,
        vendorId: String(vendorId),
        amount: String(purchaseForm.amount),
        purchaseDescription: String(purchaseForm.purchaseDescription || ""),
        purchaseDate: String(purchaseForm.purchaseDate),
      });
      if (res?.data?.responseCode === "00") {
        toast.success(res?.data?.responseMessage || "Purchase added");
        setPurchaseOpen(false);
        setPurchaseVendor(null);
      } else {
        toast.error(res?.data?.responseMessage || "Failed to add purchase");
      }
    } catch (e) {
      console.error(e);
      toast.error("API error while adding purchase");
    } finally {
      setAddingPurchase(false);
    }
  }

  /** Purchase History */
  async function fetchVendorPurchaseDetails() {
    if (!userID) return toast.error("Missing userid");
    if (!fromDate || !toDate) return toast.warning("Please select From and To dates.");
    try {
      setPurchaseLoading(true);
      const res = await call(API.PURCHASE_LIST, {
        userid: userID,
        fromDate: String(fromDate),
        toDate: String(toDate),
      });
      if (res?.data?.responseCode === "00") {
        setPurchaseRows(Array.isArray(res.data.response) ? res.data.response : []);
      } else {
        setPurchaseRows([]);
        // toast.error(res?.data?.responseMessage || "Failed to fetch purchase history");
      }
    } catch (e) {
      console.error(e);
      toast.error("API error while fetching purchase history");
    } finally {
      setPurchaseLoading(false);
    }
  }

  /** Effects */
  useEffect(() => {
    fetchVendors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userID, baseUrl]);
  useEffect(() => {
    fetchVendorPurchaseDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userID, fromDate, toDate]);
  /** Search filter */
  const filtered = useMemo(() => {
    const needle = q.trim().toLowerCase();
    if (!needle) return rows;
    return rows.filter((r) =>
      [
        r.vendorName,
        r.vendorType,
        r.vendorCategory,
        r.vendorAddress,
        r.gst,
        r.mobile,
        r.state,
        r.city,
        r.accountNumber ?? r.account_number,
        r.ifscCode ?? r.ifsc,
        r.vendorId ?? r.id,
        r.activation_status,
      ]
        .map((v) => String(v || "").toLowerCase())
        .some((s) => s.includes(needle))
    );
  }, [rows, q]);

  /** Utilities */
  function ensureOptionPresence(list, value) {
    if (!value) return list;
    return list.includes(value) ? list : [value, ...list];
  }
  const vendorTypeOptions = ensureOptionPresence(VENDOR_TYPES, form.vendorType);
  const productCategoryOptions = ensureOptionPresence(PRODUCT_CATEGORIES, form.vendorCategory);

  /** Drawer open/close */
  function openAdd() {
    setMode("add");
    setEditing(null);
    setForm({
      vendorName: "",
      vendorType: "",
      vendorCategory: "",
      vendorAddress: "",
      gst: "",
      mobile: "",
      state: "",
      city: "",
      accountNumber: "",
      ifscCode: "",
      vendorId: null,
    });
    setOpen(true);
  }
  function openEdit(row) {
    setMode("edit");
    setEditing(row);
    setForm({
      vendorName: val(row.vendorName, ""),
      vendorType: val(row.vendorType, ""),
      vendorCategory: val(row.vendorCategory, ""),
      vendorAddress: val(row.vendorAddress, ""),
      gst: val(row.gst, ""),
      mobile: val(row.mobile, ""),
      state: val(row.state, ""),
      city: val(row.city, ""),
      accountNumber: val(row.accountNumber, row.account_number, ""),
      ifscCode: val(row.ifscCode, row.ifsc, ""),
      vendorId: val(row.id, row.vendorId, null),
    });
    setOpen(true);
  }
  function closeDrawer() {
    if (!submitting) {
      setOpen(false);
      setEditing(null);
      toast.info("Action cancelled", { autoClose: 900 });
    }
  }

  /** Form validate */
  function validate() {
    if (!form.vendorName.trim()) return "Vendor name is required";
    if (form.mobile && !/^[6-9]\d{9}$/.test(form.mobile)) return "Enter valid 10-digit mobile";
    if (form.accountNumber && !/^\d{6,18}$/.test(form.accountNumber))
      return "Account number should be 6–18 digits";
    if (form.ifscCode && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(form.ifscCode.toUpperCase()))
      toast.info("IFSC format usually looks like ABCD0XXXXXX");
    return null;
  }
  async function onSubmit(e) {
    e?.preventDefault?.();
    const err = validate();
    if (err) return toast.warning(err);
    if (mode === "add") {
      await addVendor({ ...form });
    } else {
      if (!form.vendorId) return toast.error("vendorId missing for edit");
      await editVendor({ ...form });
    }
  }

  /** Navigation */
  function onCreatePurchase(row) {
    navigate("/Inventory/Vendors/CreatePurchase", { state: { vendor: row } });
  }

 return (
  <div className="inv-industrial-wrap">
    <ToastContainer position="top-right" theme="colored" closeOnClick pauseOnHover={false} />

    {/* Header (Inventory-style) */}
    <div className="inv-industrial-head">
      <div className="inv-industrial-title">
        <h1 className="CreateCampaign">Vendor Management</h1>
        {/* <div className="inv-industrial-sub">
          Table Source: <span className="inv-mono">{API.LIST}</span>
        </div> */}
      </div>

      <div className="inv-industrial-actions">
        {/* Vendor Balance */}
        <div className="inv-balance-pill" title="Vendor Payment Balance">
          <span className="inv-balance-label">Vendor Balance</span>
          <span className="inv-balance-value">₹ {vendorBalance}</span>
        </div>

        {/* Global Add Purchase */}
        <button
          type="button"
          className="inv-btn inv-btn-primary"
          onClick={() => setGlobalPurchaseOpen(true)}
          disabled={loading}
        >
          <FilePlus2 size={16} />
          Add Purchase
        </button>

        {/* Add Vendor */}
        <button
          type="button"
          className="inv-btn inv-btn-primary"
          onClick={openAdd}
          disabled={submitting || loading}
        >
          <Plus size={16} />
          Add Vendor
        </button>

        {/* Refresh */}
        <button
          type="button"
          className="inv-btn inv-btn-ghost"
          onClick={fetchVendors}
          disabled={loading}
          title="Refresh"
        >
          <RefreshCcw size={16} />
        </button>
      </div>
    </div>

    {/* Tabs (Inventory-style) */}
    <div className="inv-tabs">
      <button
        type="button"
        className={`inv-tab ${activeTab === "vendors" ? "active" : ""}`}
        onClick={() => setActiveTab("vendors")}
      >
        <Table size={16} />
        Vendors
      </button>
      <button
        type="button"
        className={`inv-tab ${activeTab === "purchases" ? "active" : ""}`}
        onClick={() => setActiveTab("purchases")}
      >
        <History size={16} />
        Purchase History
      </button>
    </div>

    {/* Search + Meta (Inventory-style) */}
    <div className="inv-toolbar-row">
      <div className="inv-industrial-search">
        <Search size={16} />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search by name, GST, mobile, IFSC, city, status…"
        />
      </div>

      <div className="inv-toolbar-meta">
        <span className="inv-pill">Total: {rows.length}</span>
        {loading ? <span className="inv-pill muted">Loading…</span> : null}
      </div>
    </div>

    {/* VENDORS TAB */}
    {activeTab === "vendors" && (
      <div className="inv-industrial-card">
        <div className="inv-industrial-table">
          {/* Head row */}
          <div
            className="inv-industrial-row inv-industrial-headrow"
            style={{
              gridTemplateColumns:
                "1.4fr 1.2fr 140px 120px 120px 170px 120px 160px 160px 120px",
            }}
          >
            <div>Vendor</div>
            <div>Type / Category</div>
            <div>Mobile</div>
            <div>State</div>
            <div>City</div>
            <div>Account #</div>
            <div>Status</div>
            <div>Created On</div>
            <div>Add Purchase</div>
            <div className="inv-industrial-right">Actions</div>
          </div>

          {loading ? (
            <div className="inv-industrial-empty">Loading…</div>
          ) : filtered.length === 0 ? (
            <div className="inv-industrial-empty">No vendors found.</div>
          ) : (
            filtered.map((r) => {
              const name = val(r.vendorName, "—");
              const vType = val(r.vendorType, "—");
              const vCat = val(r.vendorCategory, "—");
              const gst = val(r.gst, "—");
              const mobile = val(r.mobile, "—");
              const state = val(r.state, "—");
              const city = val(r.city, "—");
              const acct = val(r.accountNumber, r.account_number, "—");
              const created = val(r.createdOn, r.created_on, "—");
              const status = String(val(r.activation_status, "active")).toLowerCase();
              const isActive = status === "active";

              return (
                <div
                  className="inv-industrial-row"
                  key={val(r.id, r.vendorId, Math.random())}
                  style={{
                    gridTemplateColumns:
                      "1.4fr 1.2fr 140px 120px 120px 170px 120px 160px 160px 120px",
                  }}
                >
                  {/* Vendor */}
                  <div className="inv-industrial-name">
                    <div className="inv-industrial-name-main">{name}</div>
                    <div className="inv-industrial-name-sub inv-mono" title={gst}>
                      GST: {gst}
                    </div>
                  </div>

                  {/* Type / Category */}
                  <div className="inv-chip-wrap">
                    <span className="inv-chip">{vType}</span>
                    <span className="inv-chip" style={{ opacity: 0.75 }}>
                      {vCat}
                    </span>
                  </div>

                  {/* Mobile */}
                  <div className="inv-mono">{mobile}</div>

                  {/* State */}
                  <div>{state}</div>

                  {/* City */}
                  <div>{city}</div>

                  {/* Account */}
                  <div className="inv-mono" title={acct}>
                    {maskAcct(acct)}
                  </div>

                  {/* Status */}
                  <div>
                    {isActive ? (
                      <span className="inv-badge-industrial green">Active</span>
                    ) : (
                      <span className="inv-badge-industrial red">Inactive</span>
                    )}
                  </div>

                  {/* Created On */}
                  <div className="inv-mono">{fmtDate(created)}</div>

                  {/* Add Purchase */}
                  <div>
                    <button
                      type="button"
                      className="inv-btn inv-btn-primary"
                      style={{ padding: "8px 10px", borderRadius: 10 }}
                      onClick={() => openAddPurchase(r)}
                    >
                      <FilePlus2 size={16} />
                      Add
                    </button>
                  </div>

                  {/* Actions */}
                  <div className="inv-industrial-actions-cell">
                    <button
                      type="button"
                      className="inv-iconbtn primary"
                      title="Edit"
                      onClick={() => openEdit(r)}
                    >
                      <Pencil size={16} />
                    </button>
                    {/* Delete intentionally disabled in your original code */}
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    )}

    {/* PURCHASE HISTORY TAB */}
  {/* PURCHASE HISTORY TAB */}
{activeTab === "purchases" && (
  <div className="inv-industrial-card">
    <div className="inv-industrial-table">
      {/* Head Row */}
      <div
        className="inv-industrial-row inv-industrial-headrow"
        style={{
          gridTemplateColumns:
            "120px 1.6fr 2fr 140px 140px 110px 140px 180px 160px",
        }}
      >
        <div>Purchase ID</div>
        <div>Vendor</div>
        <div>Description</div>
        <div className="inv-industrial-right">Amount</div>
        <div>Purchase Date</div>
        <div>Status</div>
        <div>Mode</div>
        <div>Account #</div>
        <div>Created On</div>
      </div>

      {purchaseLoading ? (
        <div className="inv-industrial-empty">Loading…</div>
      ) : purchaseRows.length === 0 ? (
        <div className="inv-industrial-empty">No purchase records.</div>
      ) : (
        purchaseRows.map((p) => {
          const paid = String(p.paid).toUpperCase() === "Y";

          return (
            <div
              key={p.id}
              className="inv-industrial-row"
              style={{
                gridTemplateColumns:
                  "120px 1.6fr 2fr 140px 140px 110px 140px 180px 160px",
              }}
            >
              {/* Purchase ID */}
              <div className="inv-mono">{p.id}</div>

              {/* Vendor Name */}
              <div className="inv-industrial-name">
                <div className="inv-industrial-name-main">
                  {p.vendor_name || "—"}
                </div>
                <div className="inv-industrial-name-sub inv-mono">
                  Vendor ID: {p.fk_vendor_id}
                </div>
              </div>

              {/* Description */}
              <div
                className="inv-industrial-cat"
                title={p.purchase_description}
              >
                {p.purchase_description || "—"}
              </div>

              {/* Amount */}
              <div className="inv-industrial-right inv-mono">
                ₹{Number(p.amount || 0).toFixed(2)}
              </div>

              {/* Purchase Date */}
              <div>{p.purchase_date || "—"}</div>

              {/* Paid Status */}
              <div>
                {paid ? (
                  <span className="inv-badge-industrial green">Paid</span>
                ) : (
                  <span className="inv-badge-industrial red">Unpaid</span>
                )}
              </div>

              {/* Mode */}
              <div className="inv-mono">{p.mode || "—"}</div>

              {/* Account */}
              <div className="inv-mono" title={p.ifsc_code}>
                {p.account_number
                  ? `••••${p.account_number.slice(-4)}`
                  : "—"}
              </div>

              {/* Created On */}
              <div className="inv-mono">{p.created_on || "—"}</div>
            </div>
          );
        })
      )}
    </div>
  </div>
)}


    {/* KEEP your existing drawer/modal blocks as-is below (they depend on CreditStyle.css) */}
    {/* ADD / EDIT VENDOR */}
      {open && (
        <div className="admin-drawer-backdrop" onClick={closeDrawer}>
          <div className="admin-drawer admin-drawer-compact" onClick={(e) => e.stopPropagation()}>
            <div className="admin-drawer-header">
              <h4 className="admin-drawer-title">{mode === "add" ? "Add Vendor" : "Edit Vendor"}</h4>
              <button className="admin-icon-btn" onClick={closeDrawer}>
                <X size={18} />
              </button>
            </div>

            <form className="admin-drawer-body admin-drawer-form admin-drawer-scroll" onSubmit={onSubmit}>
              <div className="admin-field">
                <label>
                  Vendor Name <span className="req">*</span>
                </label>
                <input
                  className="admin-input-control"
                  value={form.vendorName}
                  onChange={(e) => setForm((f) => ({ ...f, vendorName: e.target.value }))}
                  required
                />
              </div>

              <div className="admin-field">
                <label>Vendor Type</label>
                <select
                  className="admin-input-control"
                  value={form.vendorType}
                  onChange={(e) => setForm((f) => ({ ...f, vendorType: e.target.value }))}
                >
                  <option value="">Select Vendor Type</option>
                  {vendorTypeOptions.map((t) => (
                    <option key={t} value={t}>
                      {t}
                    </option>
                  ))}
                </select>
              </div>

              <div className="admin-field">
                <label>Product Category</label>
                <select
                  className="admin-input-control"
                  value={form.vendorCategory}
                  onChange={(e) => setForm((f) => ({ ...f, vendorCategory: e.target.value }))}
                >
                  <option value="">Select Product Category</option>
                  {productCategoryOptions.map((c) => (
                    <option key={c} value={c}>
                      {c}
                    </option>
                  ))}
                </select>
              </div>

              <div className="admin-field">
                <label>Address</label>
                <textarea
                  className="admin-input-control"
                  rows={3}
                  value={form.vendorAddress}
                  onChange={(e) => setForm((f) => ({ ...f, vendorAddress: e.target.value }))}
                />
              </div>

              <div className="admin-field">
                <label>GST</label>
                <input
                  className="admin-input-control mono"
                  value={form.gst}
                  onChange={(e) => setForm((f) => ({ ...f, gst: e.target.value }))}
                />
              </div>

              <div className="admin-field">
                <label>Mobile</label>
                <input
                  className="admin-input-control mono"
                  inputMode="numeric"
                  maxLength={10}
                  value={form.mobile}
                  onChange={(e) =>
                    setForm((f) => ({ ...f, mobile: e.target.value.replace(/\D/g, "").slice(0, 10) }))
                  }
                />
              </div>

              <div className="admin-field">
                <label>State</label>
                <input
                  className="admin-input-control"
                  value={form.state}
                  onChange={(e) => setForm((f) => ({ ...f, state: e.target.value }))}
                />
              </div>

              <div className="admin-field">
                <label>City</label>
                <input
                  className="admin-input-control"
                  value={form.city}
                  onChange={(e) => setForm((f) => ({ ...f, city: e.target.value }))}
                />
              </div>

              <div className="admin-field">
                <label>Account Number</label>
                <input
                  className="admin-input-control mono"
                  inputMode="numeric"
                  maxLength={18}
                  value={form.accountNumber}
                  onChange={(e) =>
                    setForm((f) => ({
                      ...f,
                      accountNumber: e.target.value.replace(/\D/g, "").slice(0, 18),
                    }))
                  }
                  placeholder="e.g., 012345678901"
                />
              </div>

              <div className="admin-field">
                <label>IFSC Code</label>
                <input
                  className="admin-input-control mono"
                  value={form.ifscCode}
                  onChange={(e) =>
                    setForm((f) => ({ ...f, ifscCode: e.target.value.toUpperCase().slice(0, 11) }))
                  }
                  placeholder="e.g., HDFC0001234"
                />
              </div>

              <div className="admin-drawer-footer sticky-footer">
                <button type="button" className="admin-btn admin-btn-neutral btn--md" onClick={closeDrawer}>
                  Cancel
                </button>
                <button type="submit" className="admin-btn admin-btn-primary btn--md" disabled={submitting}>
                  {submitting ? <Loader2 className="admin-spin" size={16} /> : null}
                  {mode === "add" ? "Save" : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* PAY MODAL */}
      {payOpen && (
        <div className="admin-modal-backdrop" onClick={closePay}>
          <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
            <div className="admin-modal-header">
              <h4 className="admin-drawer-title">Pay / Settle Purchase</h4>
              <button className="admin-icon-btn" onClick={closePay}>
                <X size={18} />
              </button>
            </div>

            <div className="admin-drawer-body admin-drawer-form">
              <div className="admin-field">
                <label>Vendor</label>
                <div className="admin-input-control" style={{ opacity: 0.9 }}>
                  {payContext.vendorName || "—"} (Vendor ID: {payContext.vendorId || "—"})
                </div>
              </div>
              <div className="admin-field">
                <label>Purchase ID</label>
                <div className="admin-input-control mono" style={{ opacity: 0.9 }}>
                  {payContext.purchaseId || "—"}
                </div>
              </div>
              {/* Amount shown as read-only per requirement */}
              <div className="admin-field">
                <label>Amount</label>
                <div className="admin-input-control mono" style={{ opacity: 0.9 }}>
                  {toCurrency(payAmount)}
                </div>
              </div>
              <div className="admin-field">
                <label>Mode</label>
                <div className="admin-input-control mono" style={{ opacity: 0.9, textTransform: "uppercase" }}>
                  {payMode}
                </div>
              </div>
            </div>

            <div className="admin-modal-actions">
              <button className="admin-btn admin-btn-neutral btn--md" onClick={closePay} disabled={paying}>
                Cancel
              </button>
              <button className="admin-btn admin-btn-primary btn--md" onClick={processVendorPaymentUnified} disabled={paying}>
                {paying ? <Loader2 className="admin-spin" size={16} /> : <IndianRupee size={16} />}
                <span style={{ marginLeft: 6 }}>
                  {paying ? "Processing…" : payMode === "cash" ? "Confirm Cash" : "Pay (IMPS)"}
                </span>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ADD PURCHASE MODAL */}
      {purchaseOpen && (
        <div className="admin-modal-backdrop" onClick={closeAddPurchase}>
          <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
            <div className="admin-modal-header">
              <h4 className="admin-drawer-title">Add Purchase</h4>
              <button className="admin-icon-btn" onClick={closeAddPurchase}>
                <X size={18} />
              </button>
            </div>

            <div className="admin-drawer-body admin-drawer-form admin-drawer-scroll">
              <div className="admin-field">
                <label>Vendor</label>
                <div className="admin-input-control" style={{ opacity: 0.9 }}>
                  {purchaseVendor?.vendorName || "—"} (ID: {val(purchaseVendor?.id, purchaseVendor?.vendorId, "—")})
                </div>
              </div>

              <div className="admin-field">
                <label>
                  Amount <span className="req">*</span>
                </label>
                <input
                  className="admin-input-control mono"
                  inputMode="decimal"
                  placeholder="e.g., 1500 or 1500.50"
                  value={purchaseForm.amount}
                  onChange={(e) =>
                    setPurchaseForm((f) => ({
                      ...f,
                      amount: e.target.value
                        .replace(/[^0-9.]/g, "")
                        .replace(/(\..*)\./g, "$1")
                        .slice(0, 12),
                    }))
                  }
                />
              </div>

              <div className="admin-field">
                <label>Description</label>
                <textarea
                  className="admin-input-control"
                  rows={3}
                  placeholder="Optional description"
                  value={purchaseForm.purchaseDescription}
                  onChange={(e) => setPurchaseForm((f) => ({ ...f, purchaseDescription: e.target.value }))}
                />
              </div>

              <div className="admin-field">
                <label>
                  Purchase Date <span className="req">*</span>
                </label>
                <input
                  type="date"
                  className="admin-input-control"
                  value={purchaseForm.purchaseDate}
                  onChange={(e) => setPurchaseForm((f) => ({ ...f, purchaseDate: e.target.value }))}
                />
              </div>
            </div>

            <div className="admin-modal-actions">
              <button className="admin-btn admin-btn-neutral btn--md" onClick={closeAddPurchase} disabled={addingPurchase}>
                Cancel
              </button>
              <button className="admin-btn admin-btn-primary btn--md" onClick={submitAddPurchase} disabled={addingPurchase}>
                {addingPurchase ? <Loader2 className="admin-spin" size={16} /> : null}
                Add Purchase
              </button>
            </div>
          </div>
        </div>
      )}

    <AddVendorPurchaseModal
      isOpen={globalPurchaseOpen}
      onClose={() => setGlobalPurchaseOpen(false)}
      userID={userID}
      onSuccess={fetchVendorPurchaseDetails}
    />
  </div>
);

}
